import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import SetupScreen from './components/SetupScreen';
import FileList from './components/FileList';

const App: React.FC = () => {
    const [showSettings, setShowSettings] = useState(false);
    const [hasSettings, setHasSettings] = useState(false);

    useEffect(() => {
        const checkSettings = () => {
            const cookies = document.cookie.split('; ');
            const getCookieValue = (name: string) =>
                cookies.find((row) => row.startsWith(`${name}=`))?.split('=')[1] || '';
            
            const hasRequired = !!(getCookieValue('storageAccountName') && getCookieValue('containerName'));
            setHasSettings(hasRequired);
            setShowSettings(!hasRequired);
        };

        checkSettings();
    }, []);

    return (
        <div className="app-layout">
            <Header 
                showSettings={showSettings}
                onNavigate={() => setShowSettings(!showSettings)} 
            />
            <main className="page-container">
                {showSettings ? (
                    <SetupScreen onComplete={() => {
                        setHasSettings(true);
                        setShowSettings(false);
                    }} />
                ) : (
                    <FileList />
                )}
            </main>
        </div>
    );
};

export default App;
